// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3jNbs","options":"AnswerScale_options__wJp25","selected":"AnswerScale_selected__3DAGe"};